import type { Error } from '@ps/web-shared-validators';

export const mustNotContainSymbols =
  (regexStr: RegExp, message?: Error['message']) =>
  (value: string): Error => ({
    valid: !regexStr.test(value),
    message
  });

export const mustBeBiggerOrEqual =
  (minLength: number, message?: Error['message']) =>
  (value: string): Error => ({
    valid: !value || value.length >= minLength,
    message
  });

export const mustBeLowerOrEqual =
  (maxLength: number, message?: Error['message']) =>
  (value: string): Error => ({
    valid: !value || value.length <= maxLength,
    message
  });
